export default __webpack_public_path__ + "static/media/Ilus-Optimiza.31af5ba3.svg";